import { defineStore } from "pinia";
import { getDiscountedPrice } from "@/helpers/pricing";
import { useCartStore } from "./cart.store";
import { useProductsStore } from "./products.store";
import { lsGet, lsGetJson } from "@/helpers/storage.js";

export const useFastDeliveryCartStore = defineStore({
    id: "fastDeliveryCart",

    state: () => ({
        products: lsGet("fast_delivery_cart") ? lsGetJson("fast_delivery_cart", []) : [],
        lastOrderId: null,
        checkoutId: null,
        integrity: null,
        onlinePayMentMethod: "visa",
        modalState: {
            isOpen: false,
            message: "",
            confirmAction: null,
            cancelAction: null,
        },
    }),

    getters: {
        productGroupById: (state) => {
            return state.products.reduce((acc, obj) => {
                const group = acc.find((group) => group.id === obj.id);
                if (!group) {
                    acc.push(obj);
                }
                return acc;
            }, []);
        },

        totalPrice: (state) => {
            const subtotal = state.products.reduce((total, product) => {
                const price = typeof product.minimum_price === "number" && product.minimum_price > 0
                    ? product.minimum_price
                    : 0;

                const discountPercent = typeof product.discount_percent === "number" && product.discount_percent >= 0
                    ? product.discount_percent
                    : 0;

                const discountedPrice = parseFloat(getDiscountedPrice(price, discountPercent));

                return total + discountedPrice;
            }, 0);

            return subtotal.toFixed(2);
        },

        itemCount: (state) => {
            return state.products.length;
        },

        hasFastDeliveryProducts: (state) => {
            return state.products.length > 0;
        }
    },

    actions: {
        addToCart(product) {
            const cartStore = useCartStore();
            if (cartStore.products.length > 0) {
                this.triggerCartConflictModal(product, cartStore);
                return false;
            } else {
                useProductsStore().isFastDelivery = true;
                this.products.push(product);
                this.updateLocalStorage();
                return true;

            }
        },
        removeFromCart(id) {
            const indexToRemove = this.products.findIndex(
                (product) => product.id == id
            );

            if (indexToRemove !== -1) {
                this.products.splice(indexToRemove, 1);
                this.updateLocalStorage();
            }
        },

        removeItem(id) {
            this.products = this.products.filter((product) => product.id !== id);
            this.updateLocalStorage();
        },

        removeItemByVariant(productId, variantId) {
            this.products = this.products.filter((product) => {
                if (product.id === productId) {
                    if (product.variants && product.variants.length > 0) {
                        return product.variants[0].id !== variantId;
                    }
                    return true;
                }
                return true;
            });
            this.updateLocalStorage();
        },

        editCartItem(updatedProduct) {
            const indexToEdit = this.products.findIndex(
                (product) => product.id == updatedProduct.id
            );
            if (indexToEdit !== -1) {
                this.products[indexToEdit] = {
                    ...this.products[indexToEdit],
                    ...updatedProduct,
                };
                this.updateLocalStorage();
            }
        },

        clearCart() {
            this.products = [];
            this.updateLocalStorage();
        },

        updateLocalStorage() {
            localStorage.setItem("fast_delivery_cart", JSON.stringify(this.products));
        },

        transferToMainCart(useCartStore) {
            // Transfer all fast delivery products to the main cart
            for (const product of this.products) {
                useCartStore.addToCart(product);
            }
            this.clearCart();
        },

        triggerCartConflictModal(product, cartStore) {

            this.modalState = {
                isOpen: true,
                message: "لا يمكنك إضافة منتجات سريعة التوصيل مع منتجات عادية, هل تريد تفريغ السلة؟",
                confirmAction: () => {
                    cartStore.clearCart();
                    useProductsStore().isFastDelivery = true;
                    this.products.push(product);
                    this.updateLocalStorage();
                    this.modalState.isOpen = false;
                },
                cancelAction: () => {
                    this.modalState.isOpen = false;
                },
            };
        },
    },
});